import { useCallback, useState } from "react";
import { getBase64 } from "libs/globalFunctions";
import { createGameHistoryPendingFile, type GameHistoryPendingFile } from "./constants";

export async function pendingFilesFromAcceptedFiles(
	acceptedFiles: File[],
): Promise<GameHistoryPendingFile[]> {
	const newFiles: GameHistoryPendingFile[] = [];
	for (const file of acceptedFiles) {
		const base64 = (await getBase64(file)) as string;
		newFiles.push(createGameHistoryPendingFile(file, base64));
	}

	return newFiles;
}

export function usePendingFilesList() {
	const [files, setFiles] = useState<GameHistoryPendingFile[]>([]);

	const onFileDrop = useCallback(async (acceptedFiles: File[]) => {
		const newFiles = await pendingFilesFromAcceptedFiles(acceptedFiles);
		setFiles((prev) => [...prev, ...newFiles]);
	}, []);

	const removeFile = useCallback((fileId: string) => {
		setFiles((prev) => prev.filter((f) => f.id !== fileId));
	}, []);

	const clear = useCallback(() => {
		setFiles([]);
	}, []);

	return { files, onFileDrop, removeFile, clear };
}
